import { Component, ElementRef, EventEmitter, HostListener, Output, inject, signal, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { EMOJI_CATEGORIES, EmojiInfo } from './emoji.data';

@Component({
  selector: 'app-emoji-picker',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './emoji-picker.html',
  styleUrl: './emoji-picker.scss',
})
export class EmojiPicker {
  private elementRef = inject(ElementRef);

  @Output() selectEmoji = new EventEmitter<string>();
  @Output() closePicker = new EventEmitter<void>();

  // --- Static categories data ---
  public categories = EMOJI_CATEGORIES;

  // --- State Signals ---
  public activeCategoryId = signal<string>('smileys');
  public searchQuery = signal<string>('');
  public hoveredEmoji = signal<EmojiInfo | null>(null);

  // --- Computed filtered emojis when searching ---
  public filteredEmojis = computed(() => {
    const query = this.searchQuery().toLowerCase().trim();
    if (!query) {
      return [];
    }

    const matches: EmojiInfo[] = [];
    for (const cat of this.categories) {
      for (const emoji of cat.emojis) {
        if (
          emoji.name.toLowerCase().includes(query) ||
          emoji.keywords.some((keyword) => keyword.toLowerCase().includes(query))
        ) {
          matches.push(emoji);
        }
      }
    }
    return matches;
  });

  /**
   * Emit selected emoji.
   */
  public select(emojiChar: string) {
    this.selectEmoji.emit(emojiChar);
  }

  /**
   * Listen to all document clicks to close picker if user clicks outside.
   */
  @HostListener('document:click', ['$event'])
  public onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!this.elementRef.nativeElement.contains(target)) {
      this.closePicker.emit();
    }
  }
}
